/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  filterLoans,
} from '../actions/loans.action';

const initialState = {
  loanListStatus: 'idle',
};

const loanSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(filterLoans.fulfilled, (state, action) => {
        state.loanListStatus = 'complete';
      })
      .addCase(filterLoans.pending, (state, action) => {
        state.loanListStatus = 'loading';
      })
      .addCase(filterLoans.rejected, (state, action) => {
        state.loanListStatus = 'failed';
      });
  },
});

export default loanSlice.reducer;
